const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/persons/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */
import { getFindAllPersonsQueryOptions } from '@api';
import { createTableQuerySchema } from '@common*';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
const personsSearchSchema = createTableQuerySchema({});
export const Route = createFileRoute('/_rootLayout/persons/')({
  validateSearch: search => personsSearchSchema.parse(search),
  loader: async ({
    context: {
      queryClient
    },
    location
  }) => {
    const search = personsSearchSchema.parse(location.search);
    queryClient.ensureQueryData(getFindAllPersonsQueryOptions(search));
    return {
      crumb: t('NAVIGATION.PERSONS'),
      to: '/persons'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});